export enum LogName {
    OneTrustJavaScript = 'onetrust_javascript',
    OneTrustJSON = 'onetrust_json',
}